module.exports = __webpack_public_path__ + "static/lliira-symbol-SCAG-246bd4eaac86ba7279f9f32f27713866.png";